"use client";

import React from "react";
import { motion } from "framer-motion";
import styles from "./index.module.scss";

interface AnimatedParagraphsProps {
  children: React.ReactNode;
  className?: string;
}

const AnimatedParagraphs = ({
  children,
  className = "",
}: AnimatedParagraphsProps) => {
  return (
    <motion.div
      initial={{
        WebkitMaskImage:
          "linear-gradient(to right, black 0%, black 0%, transparent 100%)",
      }}
      whileInView={{
        WebkitMaskImage:
          "linear-gradient(to right, black 0%, black 100%, transparent 100%)",
      }}
      transition={{ duration: 2, ease: "easeInOut" }}
      className={styles.textWrapper}
      viewport={{ once: true, amount: 0.5 }}
    >
      <motion.p className={`${styles.text} ${className}`}>{children}</motion.p>
    </motion.div>
  );
};

export default AnimatedParagraphs;
